import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import i18n from "../utils/languages/i18n"
import { validateEmail, validateUserByComercial } from "../utils/services/user.service";
import ValidateEmail from "../components/ValidateEmailComponent/ValidateEmail.component";

export enum validateStatus {
    OK,
    Validating,
    ComertialValidating,
    Error
}

const FinalUserValidateEmail = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const userContent = queryParams.get('userContent');

    const [status, setStatus] = useState<validateStatus>(validateStatus.Validating)
    
    useEffect(() => {
        if (userContent && !email) {
            // This means the page was opened directly for commercial validation
            setStatus(validateStatus.ComertialValidating);
        }
    }, [userContent, email]);

    useEffect(() => {
        const browserLanguage = navigator.language;
        switch (browserLanguage) {
            case 'ca-ES':
                i18n.changeLanguage("cat");
                break;
            case 'es-ES':
                i18n.changeLanguage("es");
                break;
            default:
                i18n.changeLanguage("eng");
                break;
        }

    }, [])

    useEffect(()=>{
        if(status === validateStatus.ComertialValidating && userContent){
            validateUserByComercial(userContent)
                .then((rsp) => {
                    if (rsp.status >= 200 && rsp.status < 300) {
                        setTimeout(() => setStatus(validateStatus.OK), 1000)
                    } else {
                        setTimeout(() => setStatus(validateStatus.Error), 1000)
                    }
                })
                .catch((e) => {
                    console.log('validateComercial', e);
                    setTimeout(() => setStatus(validateStatus.Error), 1000)
                })
        }
    },[status])

    useEffect(() => {
        if (email && email.length > 0 && status === validateStatus.Validating) {  
            validateEmail(email)
                .then((rsp) => {
                    if (rsp.status >= 200 && rsp.status < 300) {
                        setTimeout(() => setStatus(validateStatus.ComertialValidating), 1000)
                        console.log("Status Comertial Validating")
                        // setTimeout(() => setStatus(validateStatus.OK), 1000)
                    } else {
                        setTimeout(() => setStatus(validateStatus.Error), 1000)
                    }
                })
                .catch((e) => {
                    console.log('validateEmail', e);
                    setTimeout(() => setStatus(validateStatus.Error), 1000)
                })
        }
        else if ((!email) || (email && email.length === 0 && status === validateStatus.Validating)) {
            setTimeout(() => setStatus(validateStatus.Error), 1000)
        }
    }, [email])

    return (
        <ValidateEmail status={status} />
    )
}

export default FinalUserValidateEmail